import SalesWeeklyReport from '../pages/SalesWeeklyReport';

const SalesWeeklyReportRoute = {
  public: [],
  auth: [
    {
      name: 'Sales - Weekly report',
      path: '/report/sales-weekly',
      permissions: ['KASH', 'NSM-SPARTAN', 'admin', 'PM', 'GPM', 'COO', 'EXECUTIVE'],
      component: SalesWeeklyReport,
    },
  ],
};

export default SalesWeeklyReportRoute;
